import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import { get, includes, reduce } from 'lodash';
import UploadButton from '../atoms/GiftCardFilesUploadButton';
import ClearButton from '../atoms/ClearButton';

const styles = theme => ({
  inputLabel: {
    display: 'inline !important'
  },
  input: {
    display: 'none'
  },
  image: {
    width: '300px',
    margin: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '5px 0'
    }
  }
});

const validMineType = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];

const enhance = compose();

const Main = enhance(({ classes, label, setFiles, setPreviewImages }) => {
  const readFileAsDataURL = file => {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();

      fr.onloadend = () => {
        resolve(fr.result);
      };

      fr.onerror = () => {
        reject(fr);
      };

      fr.readAsDataURL(file);
    });
  };
  const imagePreviews = previews => {
    const readers = [];
    for (let i = 0; i < previews.length; i += 1) {
      readers.push(readFileAsDataURL(previews[i]));
    }
    Promise.all(readers).then(values => {
      setPreviewImages(values);
    });
  };

  const handleOnChange = e => {
    const validFiles = reduce(
      e.target.files,
      (res, file) => {
        const mineFile = get(file, 'type', '');
        if (includes(validMineType, mineFile)) {
          res.push(file);
        }
        return res;
      },
      []
    );
    if (validFiles.length > 0) {
      if (validFiles.length < e.target.files.length) {
        alert('形式が正しくないファイルがあります。');
      }
      setFiles(validFiles);
      imagePreviews(validFiles);
    } else {
      alert('画像の形式が正しくありま線。');
    }
    e.target.value = null;
  };

  return (
    <div>
      <InputLabel htmlFor={label} margin="dense" className={classes.inputLabel}>
        <UploadButton />
        <ClearButton
          onClickAction={() => {
            setFiles([]);
            setPreviewImages([]);
          }}
        />
      </InputLabel>
      {/* <div className={classes.previewImages}>
          {previewImages.length > 0 &&
            previewImages.map(previewImage => (
              <Card className={classes.image}>
                <CardActionArea>
                  <CardMedia component="img" image={previewImage} />
                </CardActionArea>
              </Card>
            ))}
        </div> */}
      <input
        id={label}
        multiple
        type="file"
        accept="image/jpeg,image/png,image/gif"
        className={classes.input}
        onChange={e => handleOnChange(e)}
      />
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
